let names = {
  name: 'Sindsep',
  domain: 'sindsep-es.com.br',
  protocol: 'http',
  url: 'api.sindsep-es.com.br',
  fullUrl: 'https://api.sindsep-es.com.br/',
  color: "#71228b"
};
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === 'production') {
  names.domain = 'sindsep-es.com.br',
  names.protocol = 'https';
  names.url = 'api.sindsep-es.com.br';
  names.fullUrl = 'https://api.sindsep-es.com.br/';
} 


export const NAMES = names;


export const CookieDomain = (process.env.NODE_ENV === 'production')
  ? `.${names.domain}`
  : '';




// WEBPACK FOOTER //
// ./src/config.js